export default function isStaging(): boolean {
  return window.location.host === 'staging-web.zid.sa';
}
